const fontSizes = [
    { value: 6 },
    { value: 8 },
    { value: 9 },
    { value: 10 },
    { value: 11 },
    { value: 12 },
    { value: 13 },
    { value: 14 },
    { value: 15 },
    { value: 16 },
    { value: 18 },
    { value: 24 },
    { value: 30 },
    { value: 36 },
    { value: 48 },
    { value: 60 },
    { value: 72 },
    { value: 96 },
];

export default fontSizes